import { useCallback, useEffect, useState } from 'react';
import { plansAPI } from '../services/api';

// Legacy plan name still seen on old subscriptions.
export const normalizePlanName = (name) => {
  const text = String(name || '').trim().toLowerCase();
  return text === 'core' ? 'growth' : text;
};

// Loads the public plan catalog once. `error` is true when the request failed or came back empty.
const usePlans = () => {
  const [data, setData] = useState({ plans: [], topups: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const res = await plansAPI.get();
      const plans = res.data.plans || [];
      setData({ plans, topups: res.data.topups || [] });
      if (plans.length === 0) setError(true);
    } catch (err) {
      console.error('Failed to load plans:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { ...data, loading, error, reload };
};

export default usePlans;
